import axios from '../utils/axios';
import Constants from './types';
import { formatRealNumber, getSessionId, getPayloadFromError } from '../utils';

const encodeClassificationLabel = label => {
  switch (label) {
    case 'M':
      return 'Match';
    case 'P':
      return 'Probable Match';
    case 'N':
      return 'Non-Match';
    default:
      return '?';
  }
};

const formatLoggedPairs = pairs => {
  return pairs.map(pair => {
    return {
      id: pair.linkId.substring(1),
      dateCreated: new Date(pair.dateCreated).toDateString(),
      vectorValue: pair.vectorValue,
      weight: formatRealNumber(pair.weight),
      label: encodeClassificationLabel(pair.label),
      leftRecordId: pair.leftRecordId,
      rightRecordId: pair.rightRecordId,
      nullScored: pair.isNullScored
    };
  });
};

export const loadLoggedPairs = (entityVersionId, vectorValue) => {
  const sessionId = getSessionId();

  return dispatch => {
    dispatch(loadLoggedPairsRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/logged-links',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityVersionId,
        vectorValue: vectorValue,
        maxResults: 10000
      }
    })
      .then(res => {
        dispatch(loadLoggedPairsSuccess(formatLoggedPairs(res.data)));
      })
      .catch(err => {
        dispatch(loadLoggedPairsFailure(err));
      });
  };
};

export const loadRecordPair = (entityVersionId, recordIds) => {
  const sessionId = getSessionId();
  const queryAttribs = new URLSearchParams();
  recordIds.forEach(id => {
    queryAttribs.append('recordId', id);
  });
  queryAttribs.append('entityId', entityVersionId);
  queryAttribs.append('includeCustom', true);

  return dispatch => {
    dispatch(loadRecordPairRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/records',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: queryAttribs
    })
      .then(res => {
        dispatch(loadRecordPairSuccess(res.data));
      })
      .catch(err => {
        dispatch(loadRecordPairFailure(err));
      });
  };
};

export const deleteLoggedPairs = entityVersionId => {
  const sessionId = getSessionId();

  return dispatch => {
    axios({
      method: 'delete',
      url: '/openempi-ws-rest/1.0/logged-links',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityVersionId
      }
    })
      .then(res => {
        dispatch(deleteLoggedPairsSuccess(res.data));
      })
      .catch(err => {
        dispatch(deleteLoggedPairsFailure(err));
      });
  };
};

export const clearLoggedPairsError = () => {
  return {
    type: Constants.LOGGED_PAIRS_CLEAR_ERROR
  };
};

const loadLoggedPairsRequest = () => {
  return {
    type: Constants.LOGGED_PAIRS_GET_REQUEST
  };
};

const loadLoggedPairsSuccess = data => {
  return {
    type: Constants.LOGGED_PAIRS_GET_SUCCESS,
    payload: data
  };
};

const loadLoggedPairsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.LOGGED_PAIRS_GET_FAILURE,
    payload
  };
};

const deleteLoggedPairsSuccess = data => {
  return {
    type: Constants.LOGGED_PAIRS_DELETE_SUCCESS
  };
};

const deleteLoggedPairsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.LOGGED_PAIRS_DELETE_FAILURE,
    payload
  };
};

const loadRecordPairRequest = () => {
  return {
    type: Constants.LOGGED_RECORDPAIR_GET_REQUEST
  };
};

const loadRecordPairSuccess = data => {
  return {
    type: Constants.LOGGED_RECORDPAIR_GET_SUCCESS,
    payload: data
  };
};

const loadRecordPairFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.LOGGED_RECORDPAIR_GET_FAILURE,
    payload
  };
};
